import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';


@Component({
  selector: 'app-trinka-cloud',
  templateUrl: './trinka-cloud.component.html',
  styleUrls: ['./trinka-cloud.component.scss']
})
export class TrinkaCloudComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Trinka云-随时随地用英文轻松写作工具');
    this.metaTagService.updateTag({ name: 'description', content: '使用Trinka云随时随地进行有效写作。Trinka始终伴你左右，在您写作的同时为您实时更正，让您随时随地获得最佳写作建议！' });
    this.metaTagService.updateTag({ name: 'keywords', content: '语法检查工具应用程序，上下文拼写纠正，学术写作应用程序，技术写作应用程序，语法纠正工具，自动语法检查工具，英语写作工具' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka云-随时随地用英文轻松写作工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: '使用Trinka云随时随地进行有效写作。Trinka始终伴你左右，在您写作的同时为您实时更正，让您随时随地获得最佳写作建议！' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/trinkacloud' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinkacloud' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
  }

}
